module.exports = __webpack_public_path__ + "img/Group1.30fe75c0.svg";